<template>
<!-- 主要页面 -->
    <div class="main">
        <myHeaderTop></myHeaderTop>
        <router-view></router-view>
         <myHeaderBottom class="myheader"></myHeaderBottom>
         <myService ></myService>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
}
</script>
<style lang="scss" scoped>
.myheader{
    margin-top:100px ;
}

</style>


// WEBPACK FOOTER //
// src/view/home/main.vue